import { useContext, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "./AuthContext";

export function AuthRequire({ children }: { children: JSX.Element }) {
  const auth = useContext(AuthContext);
  const location = useLocation();

  useEffect(() => {
    if (!auth.logged && !auth.loading) {
      localStorage.setItem("redirectUri", location.pathname + location.search);
    }
  }, [auth.logged, auth.loading, location]);

  if (auth.loading) {
    return <></>;
  }

  if (!auth.logged) {
    return <Navigate to="/auth/login" />;
  }

  return children;
}
